import React from 'react';
import Button from './Button/Button';
import './selectedPopup.css';

const SelectedContactPopup = ({ selectedItem, activityLogs, closePopup, handleEditClick }) => {
  return (
    <div className="popup">
      <div className="popup-content">
        <div className="popup-header">
          <Button onClick={closePopup} className="close-btn top-right" title="Close">×</Button>
        </div>
        <div className="popup-body">
          <div className="popup-grid">
            {/* Details Section */}
            <div className="details-section">
              <h4>Contact Details</h4>
              <p><strong>Contact ID:</strong> {selectedItem.id}</p>
              <p><strong>Name:</strong> {selectedItem.name}</p>
              <p><strong>Email:</strong> {selectedItem.email}</p>
              <p><strong>Phone No:</strong> {selectedItem.phone}</p>
              </div>
            {/* Company Details */}
            <div className="company-details-section">
              <h4>Company Details</h4>
              {selectedItem.company_name ? <p><strong>Company Name:</strong> {selectedItem.company_name}</p> : null}
              {selectedItem.company_state ? <p><strong>State:</strong> {selectedItem.company_state}</p> : null}
              {selectedItem.company_industry ? <p><strong>Industry:</strong> {selectedItem.company_industry}</p> : null}
              {selectedItem.status ? <p><strong>Status:</strong> {selectedItem.status}</p> : null}
              {selectedItem.source ? <p><strong>Source:</strong> {selectedItem.source}</p> : null}
            </div>

            {/* Response Notes */}
            <div className="response-notes-section">
              <h4>Response Notes</h4>
              {selectedItem.Comments && selectedItem.Comments.trim() !== '' ? (
                <p>{selectedItem.Comments}</p>
              ) : (
                <p>No response notes available.</p>
              )}
            </div>

            {/* Activity Logs */}
            <div className="activity-logs-section">
              <h4>Activity Logs</h4>
              {activityLogs.length > 0 ? (
                <ul>
                  {activityLogs.map((log, index) => (
                    <li key={index}>
                      <strong>{new Date(log.created_at).toLocaleString()}:</strong> {log.activity_type} - {log.description}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No activity logs available.</p>
              )}
            </div>
          </div>

          <Button
            className="lead-edit-btn"
            onClick={() => {
              handleEditClick(selectedItem);
              closePopup();
            }}
            title="Edit"
          >
            Edit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SelectedContactPopup;
